/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from "react";
import CustomCard from "../../../../../../components/CustomCard";
import {getDateTimeFromTimestamp} from "../../../../../../Apis/functions";

const MaterialApprovalBadge = ({ t, currentStatusConfig, approvalReason, approvalUser, approvalDate }) => {

    return (
        <>
            { currentStatusConfig &&
            <CustomCard
                classCard={`${currentStatusConfig.classCard}`}
                children={
                    <div className={`d-flex flex-column justify-content-start gap-12px`}>
                        <p className={`ibl-font-w-600 fs-14px ${currentStatusConfig.fontColor}`}>{t(currentStatusConfig.tittle)}</p>
                        <p className={"fs-12px ibl-font-w-600"}>{approvalReason}</p>
                        <p className={"fs-12px"}>
                            {t(currentStatusConfig.toast)} : {" "}
                            <span className={"ibl-font-w-600"}>
                                        {approvalUser}
                                    </span>
                            {" "}·{" "}
                            {getDateTimeFromTimestamp(approvalDate)}.
                        </p>
                    </div>
                }
            />
            }
        </>
    );
};

export default MaterialApprovalBadge;
